/**
 * Structure combining a Point with two additional points representing the handles or tangents attached to the first point.
 * If the additional points are null or equal to the first point the path will be sharp.
 * Left and right correspond to the direction of the underlying path.
 */
class PathDefiner {
    constructor(p, left, right) {
        this.point = p;
        this.left = left;
        this.right = right;
    }
}

export { PathDefiner };
